export function sortProducts(products, sortOrder) {
  return products.sort((a, b) => sortOrder.indexOf(a.id) - sortOrder.indexOf(b.id));
}

export function triStateDisplay(field, defaultValue = 'Unspecified') {
  return field === true
    ? 'Yes'
    : ((field === false) ? 'No' : defaultValue);
}